import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import DropdownPopper from 'components/molecules/Poppers/DropdownPopper/DropdownPopper';

const StyledMentionList = styled(DropdownPopper)`
  
  ${ComponentStyles}
`;

StyledMentionList.propTypes = {
  theme: PropTypes.object
};

export default StyledMentionList;
